import { render, staticRenderFns } from "./yPagination.vue?vue&type=template&id=f1cb45d2&scoped=true"
import script from "./yPagination.vue?vue&type=script&lang=js"
export * from "./yPagination.vue?vue&type=script&lang=js"
import style0 from "./yPagination.vue?vue&type=style&index=0&id=f1cb45d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cb45d2",
  null
  
)

export default component.exports